import * as Yup from "yup";

export const narrativeBaseValidationSchema = Yup.object({
  narrative: Yup.string().max(
    5000,
    "Narrative Message must be at most 5000 characters"
  ),
});
